import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InspectionService } from '../../../inspection/inspection.service';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-inspection-filter-cards',
  templateUrl: './inspection-filter-cards.component.html',
  styleUrls: ['./inspection-filter-cards.component.scss'],
})
export class InspectionFilterCardsComponent implements OnInit {
  @Output() searchTermUpdated = new EventEmitter<any>();
  private searchQuerySubject = new Subject<string>();
  _searchQuery = '';
  showTable = true;

  get searchQuery() {
    return this._searchQuery;
  }

  set searchQuery(search: string) {
    this._searchQuery = search;

    // // Update URL search
    // this.router.navigate([], { queryParams: { search } });
    this.searchQuerySubject.next(search);
  }

  constructor(
    public inspectionService: InspectionService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.searchQuerySubject.pipe(debounceTime(700), distinctUntilChanged()).subscribe((search: string) => {
      this.updateSearch(search);
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.searchQuery = params['search'];
      if (this.searchQuery) {
        this.searchQuerySubject.next(this.searchQuery);
      }
    });
  }

  updateSearch(search: string) {
    // Update URL search
    this.searchQuery = search;
    this.router.navigate([], { queryParams: { search }, queryParamsHandling: 'merge' });

    // Emit the search event after debouncing
    this.searchTermUpdated.emit(search);
  }

  showOptions() {
    if (!this.searchQuery) {
      return of([]);
    }

    if (this.searchQuery.length === 0 || !this.showTable) {
      return of([]);
    }
    return of([this.searchQuery]);
  }

  searchBy(field: string) {
    const queryParams: any = {
      page: 1,
      pageSize: 10,
      asc: true,
      [field]: this.searchQuery,
    };

    if (field === 'vendorName') {
      queryParams.orderBy = 'inspection.completed';
    }

    this.router.navigate(['/inspection/search'], { queryParams });
  }

  hideTable() {
    this.showTable = false;
  }

  clearSearch() {
    this.searchQuery = '';
    this.updateSearch(this.searchQuery);
    this.searchTermUpdated.emit(this.searchQuery);
  }
}
